import type { JsonRpcError } from './JsonRpcError';

export function buildResultResponse(id: string, result: unknown): string {
  // undefined は wire 上表現できず result キーが欠落するため null に正規化する
  return JSON.stringify({ jsonrpc: '2.0', id, result: result ?? null });
}

export function buildErrorResponse(id: string | null, error: JsonRpcError): string {
  // kind は wire 形式に含めない（内部分類用 discriminant）
  const { kind: _kind, ...wireError } = error;
  return JSON.stringify({ jsonrpc: '2.0', id, error: wireError });
}
